function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenrecoverGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-exit",
    d: "m20.278 32.5 3.111 3.111L34.5 24.5 23.389 13.389 20.278 16.5l5.778 5.778H4.5v4.444h21.444zm19.778-28H8.944A4.457 4.457 0 0 0 4.5 8.944v8.889h4.444V8.944h31.112v31.112H8.944v-8.889H4.5v8.889A4.457 4.457 0 0 0 8.944 44.5h31.112a4.457 4.457 0 0 0 4.444-4.444V8.944A4.457 4.457 0 0 0 40.056 4.5z",
    transform: "translate(-4.5 -4.5)",
    style: {
      fill: "#7a8b99"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenrecoverGrey);
export default __webpack_public_path__ + "static/media/tokenrecoverGrey.dd708c7aec838fe5abcc404ff1e89202.svg";
export { ForwardRef as ReactComponent };